module.exports = __webpack_public_path__ + "static/img/9-2.698ba15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/9-2.jpg
// module id = aLfO
// module chunks = 0